// src/services/apiBaseQuery.js
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiBaseURL, auth, getGuestId } from '../helper/Utility';

const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseURL(),
  prepareHeaders: (headers) => {
    const token = auth('user')?.token || auth('admin')?.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    headers.set('x-guest-id', getGuestId());
    return headers;
  },
});

export default baseQuery;